<template>
  <page>
    <v-card>
      <v-app-bar dense color="grey lighten-3" flat>
          <v-icon>mdi-filter</v-icon>
          <v-toolbar-title>Filters</v-toolbar-title>
        </v-app-bar>
      <v-card-text>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <cal-picker v-model="reportForm.createdDateFrom" :label="labels.createdDateFrom" v-validate="'required'" :data-vv-as="labels.createdDateFrom" data-vv-name="createdDateFrom" :error-messages="errors.collect('createdDateFrom')"></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker v-model="reportForm.createdDateTo" :label="labels.createdDateTo" v-validate="createdDateToValidation(reportForm.createdDateFrom)" :data-vv-as="labels.createdDateTo" data-vv-name="createdDateTo" :error-messages="errors.collect('createdDateTo')" :min="this.reportForm.uwTransDateFrom"></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field v-model="reportForm.tranId" :label="labels.tranId" :error-messages="errors.collect('tranId')" data-vv-name="tranId" :data-vv-as="labels.tranId" v-validate="'numeric|max:20'"></v-text-field>
              </v-flex>
               <v-flex xs12 md6>
                <v-autocomplete multiple :label="labels.dataFileType" :items="dataFileTypeList" v-model="reportForm.dataFileType" item-text="label" item-value="value" data-vv-name="reportForm.dataFileType" :data-vv-as="labels.dataFileType" :error-messages="errors.collect('reportForm.dataFileType')" ></v-autocomplete>
              </v-flex>
               <v-flex xs12 md6>
                <v-text-field v-model="reportForm.vehRegNo" :label="labels.vehRegNo" :error-messages="errors.collect('vehRegNo')" data-vv-name="vehRegNo" :data-vv-as="labels.vehRegNo" v-validate="'max:20'"></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
        </form>
      </v-card-text>
       <v-spacer class="mt-2"></v-spacer>
    </v-card>
     <v-form>
      <v-flex xs12>
          <v-expansion-panels v-model="panel4" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Report Setting</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-checkbox
                      :label="labels.pbPrtParam"
                      v-model="reportForm.pbPrtParam"
                      :error-messages="errors.collect('pbPrtParam')"
                      data-vv-name="pbPrtParam"
                      :data-vv-as="labels.pbPrtParam"
                    />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-spacer class="mt-3"></v-spacer>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex lg6 xs12>
            <v-btn class="mr-2" color="primary" :loading="submitting" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          </v-layout>
        </v-container>
      </v-form>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      labels: {
        createdDateFrom: 'Created Date From',
        createdDateTo: 'Created Date To',
        tranId: 'Transaction Id',
        dataFileType: 'Data File Type',
        vehRegNo: 'Vehicle Registration No',
        export: 'Export to',
        pbPrtParam: 'Print Run Time Parameters'
      },
      reportForm: {
        createdDateFrom: new Date(),
        createdDateTo: new Date(),
        tranId: '',
        vehRegNo: '',
        dataFileType: ['INS_DAT_FILE_1', 'INS_DAT_FILE_2', 'INS_DAT_FILE_3', 'INS_DAT_FILE_4'],
        format: undefined,
        pbPrtParam: true
      },
      menu: {},
      supportedFormat: ['PDF', 'XLSX'],
      dataFileTypeList: [
        { label: ' DATA FILE 1', value: 'INS_DAT_FILE_1' },
        { label: ' DATA FILE 2', value: 'INS_DAT_FILE_2' },
        { label: ' DATA FILE 3', value: 'INS_DAT_FILE_3' },
        { label: ' DATA FILE 4', value: 'INS_DAT_FILE_4' }
      ],
      submitting: false
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.init !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initPrintLTA
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    createdDateToValidation(createdDateFrom) {
      const result = 'required|from_to_date:' + createdDateFrom
      return result
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          console.log(this.reportForm)
          this.submitting = true
          let rptForm = {
            createdDateFrom: this.reportForm.createdDateFrom,
            createdDateTo: this.reportForm.createdDateTo,
            tranId: this.reportForm.tranId,
            dataFileType: this.reportForm.dataFileType,
            vehRegNo: this.reportForm.vehRegNo,
            format: this.reportForm.format,
            pbPrtParam: this.reportForm.pbPrtParam
          }
          await this.$http.post(apiURI, rptForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ]
}
</script>
